import { motion, useMotionValue, useTransform } from 'framer-motion';
import React from 'react';
import { Description, SubTitle } from '../../components/layouts';
import { DesktopContent } from './Desktop';
import Visibility from '../../components/Visibility';
import { MobileContent } from './Mobile';
import './style.scss';
import { getTrack } from '../../helpers';

const STEP_UP = -0.0025;
const STEP_DOWN = 0.0025;

const track = getTrack({ block: 19 });

export function HighRefreshRate2({ mobile = false }) {
  const ref = React.useRef();
  const x = useMotionValue(0);
  const down = useMotionValue(true);
  const running = useMotionValue(false);

  const y = useMotionValue(-1);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed } = calculations;
      y.set(percentagePassed);
      const _running = percentagePassed > -0.2 && percentagePassed < 1.2;
      running.set(_running);
    },
    [y, running]
  );

  React.useEffect(() => {
    if (!ref.current) {
      ref.current = setInterval(() => {
        if (!running.get()) {
          return;
        }
        const v = down.get() ? STEP_DOWN : STEP_UP;
        const newX = x.get() + v;
        x.set(newX);
        if (down.get() && newX > 0.999) {
          down.set(false);
        } else if (!down.get() && newX < STEP_DOWN) {
          down.set(true);
        }
      }, 17);
    }
    return () => {
      ref.current && clearInterval(ref.current);
    };
  }, [ref, x, down, running]);

  const o1 = useTransform(y, [-0.5, 0.2], [1, 1]);
  const y1 = useTransform(y, [-0.5, 0], [0, 0]);
  const y1m = useTransform(y, [-0.25, 0.25], [0, 0]);

  return (
    <Visibility fireOnMount offset={[-2000, 2000]} onUpdate={handleUpdate} className="page-section section-hrr-2 inverted" data-track={track}>
      <div className="sticky-content" style={{ overflow: 'visible' }}>
        <div>
          <motion.div className="section-content left" style={{ opacity: o1, y: mobile ? y1m : y1 }}>
            <SubTitle>
              120Hz 高刷新率{mobile ? <br /> : ''}+240Hz 高采样率
              <br />
              目光所至，尽是流畅
            </SubTitle>
            {/* <Description>
          120Hz<sup>5</sup> 屏幕刷新率，每秒高达 120 帧画面刷新，同时触控采样率也提升至 240Hz<sup>5</sup>，享受细腻的观感和流畅的操控体验。
        </Description> */}
          </motion.div>
          {!mobile && <DesktopContent x={x} />}
          {mobile && <MobileContent x={x} />}
        </div>
      </div>
    </Visibility>
  );
}
